import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import AddRole from './AddRole';
import RoleModel from './models/RoleModel';
import EditRole from './EditRole';

function RoleModal({onClose, onSubmit, UserAction, show, selectedRow}) {
    const [childData, setChildData] = useState(new RoleModel() || []);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
        setChildData(selectedRow);
    }, [selectedRow]);

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleLoad = (data) => {
        setChildData(data); // Send the form data back to the parent component
    };
    const handleCancel = (label) => {
      onClose();
    };
    if(UserAction === "Add"){
        modalAction = <AddRole  onLoad= {handleLoad} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = <EditRole RoleData={childData} onSubmit= {onSubmit} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
                            <button className="btn btn-cancel me-2" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } 
    return (
        <Modal
            show={show}
            onHide={onClose}
            backdrop="static"
        >
            <ModalHeader className="modal-header border-0 custom-modal-header">
                <ModalTitle >{userAction} Role</ModalTitle>
            <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
            </ModalHeader>
            <ModalBody>
                {modalAction}
            </ModalBody>
            <ModalFooter className="">
                {showButtons}
            </ModalFooter>
        </Modal> 
    )
}

export default RoleModal